import { useCallback } from "react";

import type { UseNavigateHomeType, UseNavigateType } from "./contract";

const useNavigate: UseNavigateType = () =>
  useCallback((url) => {
    window.location.assign(url);
  }, []);

export const useNavigateHome: UseNavigateHomeType = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    navigate("/home/");
  }, [navigate]);
};
export const useGeneratePathFavoritePage = (): URL => {
  const url = new URL(window.location.href);
  const prevHref = url.href;

  url.searchParams.append("origin", prevHref);

  return url;
};

export default useNavigate;
